import React from 'react';
import { Row, Col } from 'react-materialize';

function Footer (props) {
    return (
      <div className="footer" style={{paddingBottom: "60px"}}>
        <div style={{ display:"flex", flexDirection: "row", justifyContent:"space-between"}}>
          <div style={{marginLeft: "10%", marginTop: "5%", width: "30%"}}>
            <div className="footer-title" style={{ marginBottom: "10%"}}>
              Acknowledgments
            </div>
            <div>
              The Youth and NCDs Data Center and related analytical work were funded by the AstraZeneca Young Health Programme (YHP). YHP is a disease prevention programme with a unique focus on adolescents. It was founded in partnership with Johns Hopkins Bloomberg School of Public Health and Plan International, with local NGO partners implementing YHP programs on the ground. The YHP mission is to positively impact the health of adolescents in marginalized communities worldwide through research, advocacy, and on-the-ground programs focused on NCD prevention.
            </div>
            <div className="footer-title" style={{marginTop: "10%", marginBottom: "10%"}}>
              Contact
            </div>
            <div>
              <a href="mailto:YouthandNCDs@prb.org">YouthandNCDs@prb.org</a>
            </div>

            {/* <div style={{marginTop: "10%", display: "flex", justifyContent: "space-between"}}>
              <div>
                Sunt Culpa Qui Officia
              </div>
              <div>
                1 (888) 987-6543
              </div>
            </div> */}
            {/* <div style={{ display: "flex", justifyContent: "space-between"}}>
              <div>
                Sunt Culpa Qui Officia
              </div>
              <div>
                1 (888) 987-6543
              </div>
            </div> */}
            {/* <div style={{marginTop: "10%", display: "flex", justifyContent: "space-between"}}>
              <div>
                Sunt Culpa Qui
              </div>
              <div>
                bonjour@example.com
              </div>
            </div> */}
            {/* <div style={{ display: "flex", justifyContent: "space-between"}}>
              <div>
                Sunt Culpa Qui
              </div>
              <div>
                bonjour@example.com
              </div>
            </div> */}
          </div>

          <div style={{width: "50%", display: "flex", flexDirection: "row", marginTop: '5%', justifyContent:"space-around", flexWrap: "wrap"}}>
            <div>
              <a href="https://www.prb.org/" target="_blank" >
                <img src="prbfooter.jpg" style={{width: "168px", height: "83px"}} />
              </a>
            </div>
            <div>
              <a href="https://www.younghealthprogrammeyhp.com/" target="_blank" >
                <img src="AZ_YHP.jpg" style={{width: "168px", height: "83px"}}/>
              </a>
            </div>
            <div>
              <a href="https://plan-uk.org/donate/partnerships/private-sector/partnering-with-astrazeneca" target="_blank" >
                <img src="PI_Logo_CMYK_blue.jpg" style={{width: "168px", height: "83px"}}/>
              </a>
            </div>
            {/* <div>
              <img src="prbfooter.jpg" style={{width: "168px", height: "83px"}}/>
            </div>
            <div>
              <img src="prbfooter.jpg" style={{width: "168px", height: "83px"}}/>
            </div>
            <div>
              <img src="prbfooter.jpg" style={{width: "168px", height: "83px"}}/>
            </div> */}
          </div>
        </div><br/><br/>
        <div style={{textAlign: "center"}}>©  2020  Population  Reference  Bureau.  All  Rights  Reserved.  </div>
      </div>
      );
  }



export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js